export default {
  index: [
    {
      path: '/userbzxm',
      component: resolve => require(['./userbzxmIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/user_bzxm/_router.js